/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const COOLER_STATS_FRAGMENT = gql`
  fragment CoolerStats on CoolerStats {
    displayId
    displayName
    displayOrder
    thumbnailUrl
    revenue
    revenueTrend
    profit
    profitTrend
    complianceScore
    aiInsightsCount
    lastSnapshotDate
    latestPlanogramChangeCreatedAt
    latestPlanogramRestockCompletedAt
  }
`
